import { graphql } from "@opensea/graphql"
import { getCollectionSweepQuoteErrorFragment } from "./getCollectionSweepQuoteError.fragment"

export const CollectionSweepQuoteReceiptRangeFragment = graphql(
  `
    fragment CollectionSweepQuoteReceiptRange on CollectionSweepQuoteResponse {
      collection {
        chain {
          nativeCurrency {
            symbol
          }
        }
      }

      quote {
        ...getCollectionSweepQuoteError

        __typename
        ... on CollectionSweepQuoteSuccess {
          itemQuotes {
            pricePerItem {
              token {
                unit
                symbol
              }
              usd
            }
          }
        }
      }
    }
  `,
  [getCollectionSweepQuoteErrorFragment],
)
